import React from "react";
import { useAppSelector } from "../../../../../hooks/useAppSelector";
import GeometryEditing from "../geometry-editing";

const GeometryEditor = () => {
  const { krookiePlots, selectedCity } = useAppSelector(
    (state) => state.masterPlanModification,
  );

  return (
    <GeometryEditing
      modalMessages={{
        positive: "editing-block.modalMessagePositiveEditor",
        negative: "editing-block.modalMessageNegativeEditor",
        params: {
          number: krookiePlots[0].number,
        },
      }}
      modalTitle="editing-block.modalTitleEditor"
      validationFlags={{
        selfIntersections: true,
        duplicatePoints: true,
        intersections: true,
        outsideCityBoundary: {
          cityId: selectedCity!,
        },
      }}
    />
  );
};

export default GeometryEditor;
